import { createUseStyles } from 'react-jss'

const useTotalsStyles = createUseStyles({
  welcomeMessageSkeleton: {
    maxWidth: '100%',
    width: 600
  },
  welcomeButtonsWrapper: {
    gap: 8
  }
})

export default useTotalsStyles
